import React, { useState, memo, useEffect, useRef } from "react";
import { Card, Col, List, Row, Skeleton, Slider, Space } from "antd";
import Meta from "antd/es/card/Meta";

import {
    DropDown,
    InputField,
    SearchInput,
    SubmitButton,
    TextComponent,
} from "../../../../components";
import styles from "./PublicPLaylist.module.css";
import dummyImg from "../../../../assets/dummy.jpg";
import { AiFillStar, AiOutlineArrowRight } from "react-icons/ai";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { PlaylistMiddleware } from "../../../../Store/Middlewares/PlaylistMiddleware";


const RenderItem = memo(({ item, loader }) => {
    const { state } = useLocation();
    const navigate = useNavigate();
    return (
        <List.Item
            onClick={() => {
                // navigate("/findVendors/VendorDetails", {
                //     state: {
                //         headrTitle: item?.service_category_name ? item?.service_category_name : "",
                //         data: item,
                //         eventData: state?.eventData,
                //     },
                // });
            }}
        >
            {loader ? (
                <Space
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                        marginTop: "10px",
                    }}
                >
                    <Skeleton.Image active className={styles.image} />
                    <Skeleton.Input active size={20} />
                </Space>
            ) : (
                <Card
                    hoverable
                    style={{ width: "100%", textAlign: "center", alignItems: "center" }}
                    cover={
                        <img
                            className={styles.image}
                            src={item.image ? item.image : dummyImg}
                            alt="example"
                        />
                    }
                >
                    <Meta
                        style={{ textAlign: "center" }}
                        title={
                            <>
                                <TextComponent
                                    text={item?.name ? item?.name : '--'}
                                // textClass={styles.nameText}
                                />
                            </>
                        }
                    // description={<TextComponent text={item?.description} />}
                    />


                    <TextComponent
                        // textClass={styles.descText}
                        text={item?.description}
                    />
                    <Row className={styles.ratingCont}>
                        <div onClick={() => { navigate("/songIdeas/MusicList", { state: { headrTitle: "", data: item, }, }); }} className={styles.addSongModalDiv}>
                            <AiOutlineArrowRight color="#00000" size={30} />
                        </div>
                    </Row>
                </Card>
            )}
        </List.Item>
    );
});

const PublicPlaylist = () => {
    const [loader, setLoader] = useState(false);
    const dispatch = useDispatch();
    const Playlist = useSelector(
        state => state.PlaylistReducer?.PublicPlaylist,
    );

    const getData = (data = null) => {
        dispatch(PlaylistMiddleware.getAdminPlaylist({ name: '' })).then(() => {
            setLoader(false);
        }).catch()
    };
    useEffect(() => {
        getData()
    }, []);




    return (
        <>

            <List
                className={styles.listClass}
                grid={{
                    xs: 1,
                    sm: 2,
                    md: 2,
                    lg: 3,
                    xl: 4,
                    xxl: 4,
                }}
                dataSource={Playlist ? Playlist : []}
                renderItem={(item) => <RenderItem item={item} loader={loader} />}
                footer={
                    <div
                        style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        {/* {findVendorsPaginationByCat?.links?.next != null ? (
                            <div style={{ width: "50%" }}>
                                <SubmitButton title={"Load More"} onClick={onLoadMore} />
                            </div>
                        ) : null} */}
                    </div>
                }
            />

        </>
    );
};

export default PublicPlaylist;
